export const environment = {
  production: true,
  baseURL: '/webservice',
  fcaURL: '/fcaservice',
  oauthBaseURL:'/security',
  app1:'/app1-webservice',
  app2:'/app2-webservice',
  fcaapp1:'/app1-fcaservice',
  fcaapp2:'/app2-fcaservice',
  eaapp:'/ea-app',
};
